// extracted by mini-css-extract-plugin
export default {"wrapper":"AnnotatedImage_wrapper__6N7Ld","image":"AnnotatedImage_image__3VZ_0"};